export default __webpack_public_path__ + "static/media/envelop.61de27c4.svg";